<template>
  <section>
    <multiselect
      class="rnp-multiselect"
      v-model="valueLocal"
      :preserve-search="true"
      selectLabel=""
      deselectLabel=""
      selectedLabel="Selecionado"
      v-bind="propsSingleSelect"
      :style="borderStyleVars"
      @remove="$emit('remove', $event)"
    >
      <template slot="noOptions">
        <p>A lista está vazia</p>
      </template>
      <template slot="caret">
        <div class="icon-caret">
          <unicom-icone nome="chevron-down" :tamanho="20" />
        </div>
      </template>
    </multiselect>
    <label v-show="mostrarErrors" class="err-msg">{{ mensagemDeErro }}</label>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";

import isEqual from "lodash.isequal";

export default {
  components: { Multiselect },

  props: {
    propsSingleSelect: {
      type: Object,
      default: () => ({
        placeholder: "",
        options: [],
        "track-by": "",
        label: ""
      })
    },
    value: {
      default: () => []
    },
    // Prop para customizar a mensagem de erro mostrada
    errorMessage: {
      type: String,
      default: () => ""
    },
    // Prop para indicar que existe error.
    // Faz uso de uma standard mensagem de error
    // o jeito mais simples de usar o componente com validação
    temError: {
      type: Boolean,
      default: false
    },
    // Prop para saber se o componente tem que fazer validações
    validacao: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valueLocal: [],
      error: this.errorMessage
    };
  },

  computed: {
    mensagemDeErro() {
      if (this.error.length > 0) {
        return this.error;
      }
      if (this.temError) {
        return "Esse campo é Obrigatório";
      }
      return null;
    },
    mostrarErrors() {
      return this.$store.getters.getMostrarErrors;
    },
    borderStyleVars() {
      if (this.error && this.mostrarErrors) {
        return {
          "--border-style": "1px solid red",
          "--placeholder-style": "red"
        };
      } else {
        return {
          "--border-style": "1px solid #9e9e9e",
          "--placeholder-style": "#707070"
        };
      }
    }
  },

  watch: {
    valueLocal: {
      deep: true,
      immediate: true,
      handler(value) {
        this.$emit("input", value);

        if (!this.validacao) return;

        if (!value) {
          this.error = "Esse campo é Obrigatório";
          return this.$emit("tem-error", true);
        } else {
          this.error = "";
          this.$emit("tem-error", false);
        }

        if (Array.isArray(value) && value.length < 1) {
          this.error = "Esse campo é Obrigatório";
          this.$emit("tem-error", true);
        } else {
          this.$emit("tem-error", false);
          this.error = "";
        }
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        if (isEqual(this.valueLocal, value)) return;
        this.valueLocal = value;
      }
    },
    mensagemErro(valor) {
      this.error = valor;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.err-msg {
  color: red;
  opacity: 0.8;
}
@mixin style-scroll {
  * {
    scrollbar-width: thin;
    scrollbar-color: #bebebe #f1f2f1;
  }

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 15px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9e9e9e;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
    border-radius: 15px;
    box-shadow: inset 10px 1px 23px #f1f2f1;
  }
}

.rnp-multiselect {
  outline: 0;
  width: 100%;
  min-height: 35px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #fff;
  color: #54585e;
  cursor: pointer;

  ::v-deep {
    .multiselect__single {
      font-size: 14px;
    }
    .multiselect__tags {
      min-height: 35px;
      border: var(--border-style);
      padding: 5px 33px 0px 5px;

      input {
        font-size: 14px;
        padding: 0;
        margin-bottom: 0;

        &::placeholder,
        &::-ms-input-placeholder {
          opacity: 0.5;
          color: var(--placeholder-style);
        }
      }

      .multiselect__placeholder {
        color: var(--placeholder-style);
        opacity: 0.7;
        line-height: 20px;
        padding-top: 0;
        margin-bottom: 0;
      }

      .multiselect__tags-wrap {
        max-height: 58px;
        overflow: auto;
        display: block;
        @include style-scroll;

        .multiselect__tag {
          background-color: #b1d34b;

          .multiselect__tag-icon {
            &:hover {
              opacity: 0.6;
              background-color: #b1d34b;
            }
            &::after {
              content: "\D7";
              color: #ffffff;
              font-size: 14px;
            }
          }
        }
      }
    }
    .multiselect__content-wrapper {
      @include style-scroll;
    }
    .multiselect__option {
      white-space: initial;

      &.multiselect__option--highlight {
        background-color: #00995d;
        color: white;
      }
    }
  }

  &.multiselect--active {
    .icon-caret {
      transform: rotateZ(180deg);
    }
  }

  .icon-caret {
    display: inline-flex;
    align-items: center;
    position: absolute;
    width: 40px;
    height: 33px;
    right: 0px;
    // top: 102px;
    padding: 4px 8px;
    text-align: center;

    > div {
      height: 20px;
    }
  }
}
</style>
